import axios from "axios";
import router from "../router";

const BASE_URL =
  process.env.NODE_ENV === "production"
    ? `${window.location.origin}/`
    : "http://127.0.0.1:8080";

// https://github.com/PanJiaChen/vue-element-admin/blob/master/src/utils/request.js
const http = axios.create({
  baseURL: BASE_URL, // (process.env.NODE_ENV == 'production'?'https://app.quizmed.com.br/':'http://'+process.env.IP+':3001'),
  headers: {
    "X-Requested-With": "XMLHttpRequest"
  },
  validateStatus(status) {
    return status >= 200 && status < 400;
  }
});

/**
 * Adiciona o token de autenticacao as proximas requisicoes
 * */
http.interceptors.request.use(config => {
  const newConfig = config;
  newConfig.headers = Object.assign({}, config.headers, {
    "authentication-token": localStorage.getItem("manager_token")
  });
  return newConfig;
});

/**
 * Verifica se a resposta foi 401 e retorna para autenticacao
 * */
http.interceptors.response.use(
  response => {
    if (response.status === 401) {
      router.push({ path: "/autenticacao" });
      return false;
    }
    return response;
  },
  error => Promise.reject(error)
);

export default http;
